import { Routes } from '@angular/router';
import { BusinessModuleGuard } from '../guards/business-module.guard';
import { ExcludeBusinessModeGuard } from '../guards/exclude-business-mode.guard';

const moduleGuard = [BusinessModuleGuard];
const adminOnlyGuard = [ExcludeBusinessModeGuard];

export const content: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'prompts',
    loadChildren: () => import('../../components/grop/grop.module').then(m => m.GropModule),
  },
  {
    path: 'products',
    loadChildren: () => import('../../components/products/products.module').then(m => m.ProductsModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "Products" }
  },
  {
    path: 'Ventas',
    loadChildren: () => import('../../components/sales/sales.module').then(m => m.SalesModule),
    data: {
      breadcrumb: "Ventas"
    }
  },
  {
    path: 'coupons',
    loadChildren: () => import('../../components/coupons/coupons.module').then(m => m.CouponsModule),
    data: {
      breadcrumb: "Coupons"
    }
  },
  {
    path: 'pages',
    loadChildren: () => import('../../components/pages/pages.module').then(m => m.PagesModule),
    data: {
      breadcrumb: "Pages"
    }
  },
  {
    path: 'media',
    loadChildren: () => import('../../components/media/media.module').then(m => m.MediaModule),
  },
  {
    path: 'menus',
    loadChildren: () => import('../../components/menus/menus.module').then(m => m.MenusModule),
    data: {
      breadcrumb: "Menus"
    }
  },
  {
    path: 'users',
    loadChildren: () => import('../../components/users/users.module').then(m => m.UsersModule),
    data: {
      breadcrumb: "Users"
    }
  },
  {
    path: 'vendors',
    loadChildren: () => import('../../components/vendors/vendors.module').then(m => m.VendorsModule),
    data: {
      breadcrumb: "Vendors"
    }
  },
  {
    path: 'localization',
    loadChildren: () => import('../../components/localization/localization.module').then(m => m.LocalizationModule),
    data: {
      breadcrumb: "Localization"
    }
  },
  {
    path: 'reports',
    loadChildren: () => import('../../components/reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: 'settings',
    loadChildren: () => import('../../components/setting/setting.module').then(m => m.SettingModule),
    data: {
      breadcrumb: "Settings"
    } 
  },
  {
    path: 'invoice',
    loadChildren: () => import('../../components/invoice/invoice.module').then(m => m.InvoiceModule),
    data: {
      breadcrumb: "Invoice"
    }
  },

  {
    path: 'contactos',
    loadChildren: () => import ('../../components/eduman/leads/leads.module').then(m=> m.LeadsModule),
    canActivate: moduleGuard,
    data: { breadcrumb: 'Contactos' }
  },
  // Alias de compatibilidad: /leads → /contactos
  { path: 'leads', redirectTo: 'contactos', pathMatch: 'prefix' },
  {
    path: 'conversaciones',
    loadChildren: () => import('../../components/eduman/conversaciones/conversaciones.module').then(m => m.ConversacionesModule),
    data: { breadcrumb: 'Conversaciones' },
  },
  {
    path: 'pipelines',
    loadChildren: () => import('../../components/eduman/pipelines/pipelines.module').then(m => m.PipelinesModule),
    data: { breadcrumb: 'Oportunidades' },
  },  
  // {
  //   path: 'leads-kanban',
  //   loadChildren: () => import ('../../components/eduman/leads-kanban/leads-kanban.module').then(m=> m.LeadsKanbanModule),
  //   data: {
  //     breadcrumb: "LeadsKanban"
  //   }
  // },  
   
  {
    path: 'lead-status',
    loadChildren: () => import ('../../components/eduman/lead-status/lead-status.module').then(m=> m.LeadStatusModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "LeadStatus" }
  },
  {
    path: 'lead-funnels',
    loadChildren: () => import ('../../components/eduman/lead-funnels/lead-funnels.module').then(m=> m.LeadFunnelsModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "LeadFunnels" }
  },

  {
    path: 'landing-pages',
    loadChildren: () => import('../../components/landing-pages/landing-pages.module').then(m => m.LandingPagesModule),
    canActivate: moduleGuard,
    data: { breadcrumb: 'Landing Pages' }
  },
  {
    path: 'calendario',
    loadChildren: () => import('../../components/appointments/appointments.module').then(m => m.AppointmentsModule),
    canActivate: moduleGuard,
    data: { breadcrumb: 'Calendario' }
  },
  // Alias de compatibilidad — redirige /citas → /calendario
  { path: 'citas', redirectTo: 'calendario', pathMatch: 'prefix' },
  {
    path: 'social-media',
    loadChildren: () => import('../../components/social-media/social-media.module').then(m => m.SocialMediaModule),
    canActivate: moduleGuard,
    data: { breadcrumb: 'Redes Sociales' }
  },
  {
    path: 'Email-Marketing',
    loadChildren: () => import ('../../components/email-marketing/email-marketing.module').then(m=> m.EmailMarketingModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "Email Marketing" }
  },
  {
    path: 'Videoteca',
    loadChildren: () => import ('../../components/videoteca/videoteca.module').then(m=> m.VideotecaModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "Videoteca" }
  },
  {
    path: 'Colaboradores',
    loadChildren: () => import ('../../components/colaboradores/colaboradores.module').then(m=> m.ColaboradoresModule),
    canActivate: moduleGuard,
    data: { breadcrumb: "Colaboradores" }
  },
  {
    path: 'inicio',
    loadChildren: () => import('../../components/bienvenida/bienvenida.module').then(m => m.BienvenidaModule),
    data: { breadcrumb: "Inicio" }
  },
  { 
    path: 'students', 
    loadChildren: () => import('../../components/students/students.module').then(m => m.StudentsModule),
    data: {
      breadcrumb: "Estudiantes"
    } 
  },
  {
    path: 'enlaces',
    loadChildren: () => import('../../components/invitation-links/invitation-links.module').then(m => m.InvitationLinksModule),
    data: {
      breadcrumb: "Enlaces de Invitación"
    }
  },
  {
    path: 'negocio',
    loadChildren: () => import('../../components/business-admin/business-admin.module').then(m => m.BusinessAdminModule),
    canActivate: moduleGuard,
    data: { breadcrumb: 'Administración' },
  },
  {
    path: 'suscripciones',
    loadChildren: () => import('../../components/subscriptions/subscriptions.module').then(m => m.SubscriptionsModule),
    canActivate: adminOnlyGuard,
    data: {
      breadcrumb: "Suscripciones"
    }
  },
  // ── Mi equipo de trabajo ─────────────────────────────────────────────────
  {
    path: 'equipo',
    loadChildren: () => import('../../components/eduman/equipo/equipo.module').then(m => m.EquipoModule),
    data: { breadcrumb: 'Mi equipo' },
  },
  // ── Launchpad — wizard de configuración inicial del negocio ──────────────
  {
    path: 'launchpad',
    loadChildren: () => import('../../components/launchpad/launchpad.module').then(m => m.LaunchpadModule),
    data: { breadcrumb: 'Launchpad' },
  },
]